<template>
    <el-container>
      <el-header height="80px">
        <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
          <el-menu-item @click="back()">后退</el-menu-item>
          <el-menu-item index="/aipuruiInspectGroupIndex">首页</el-menu-item>
          <el-menu-item index="/aipuruiInspectGroup/currentDataTable?bridgeId=fe983c4c-7e10-4ccf-8099-fa0530b1da68">实时数据表</el-menu-item>
          <el-submenu :index="'/aipuruiInspectGroup/dataHistory?bridgeId=fe983c4c-7e10-4ccf-8099-fa0530b1da68&scenarioId=TBD'">
            <template slot="title">数据历史</template>
            <el-menu-item index="/aipuruiInspectGroup/dataHistory?bridgeId=fe983c4c-7e10-4ccf-8099-fa0530b1da68&scenarioId=TBD"> 查询数据历史 </el-menu-item>
            <el-menu-item index="/aipuruiInspectGroup/dataHistory?bridgeId=fe983c4c-7e10-4ccf-8099-fa0530b1da68"> 自定义数据历史 </el-menu-item>
          </el-submenu>
        </el-menu>
        <HeaderTime bridgeName="aipurui" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
      </el-header>
      <el-main class="el-main aipurui-inspect-group">
        <router-view></router-view>
      </el-main>
    </el-container>
  </template>
    <script>
  export default {
    name: "aipuruiInspectGroup",
    data() {
      return {
        bridgeId: "fe983c4c-7e10-4ccf-8099-fa0530b1da68",
        envInfo: {
          envId: "8111a34f-955c-4139-a61d-33c5349246c9",
          weather: "27c094b8-c15f-44eb-9092-88960aafed9c",
          humidity: "c2ac655a-1b6f-495d-9c76-d61be186266c",
          temperature: "16a538aa-4cc5-43fd-9c9f-3894f05b8c97",
        },
        id2Path: {},
        activeIndex: "",
        historyScenarioList: [],
      };
    },
    mounted() {
      this.activeIndex = this.$route.fullPath;
  
      document.getElementById("elMenu").addEventListener(
        "mousewheel",
        (e) => {
          let scrollWidth = document.getElementById("elMenu").scrollWidth;
          let clientWidth = document.getElementById("elMenu").clientWidth;
  
          let scrollMin = 0;
          let scrollMax = scrollWidth - clientWidth;
          let step = 30;
  
          if (e.deltaY > 0) {
            document.getElementById("elMenu").scrollLeft += step;
            if (document.getElementById("elMenu").scrollLeft > scrollMax) {
              document.getElementById("elMenu").scrollLeft = scrollMax;
            }
          } else if (e.deltaY < 0) {
            document.getElementById("elMenu").scrollLeft += step * -1;
            if (document.getElementById("elMenu").scrollLeft < scrollMin) {
              document.getElementById("elMenu").scrollLeft = scrollMin;
            }
          }
        },
        true
      );
    },
    watch: {
      $route() {
        this.activeIndex = this.$route.fullPath;
      },
    },
    methods: {
      back() {
        window.history.back();
      },
      handleSelect(key) {
        if (key !== this.activeIndex) {
          this.activeIndex = key;
          this.$router.push(key);
        }
      },
    },
  };
  </script>
    
    <style lang="scss" scoped>
  .el-menu-demo {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  
    overflow-x: scroll;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: transparent;
    display: none;
  }
  </style>